// Checking if hour/minute (usually now) fails into a range of times.
// Used in chat widgets and bot.

/**
 * Does the current hour/minute fall into the day's set time ranges.
 * @param {Number} hour Current hour in UTC.
 * @param {Number} minute Current minutes in UTC.
 * @param {Array[]} ranges Ranges covered, arrays of 2 time strings.
 * @returns {Boolean}
 */
const isCoverageInRange = function(hour, minute, ranges) {
    if (ranges.length === 0) {
        return false;
    }
    for (let i = 0; i <= ranges.length; i++) {
        const range = ranges[i];
        if (!Array.isArray(range) || range.length !== 2) {
            continue;
        }
        // Parse out hours/minutes and make sure they are ints.
        const start = range[0].split(':').map((el) => { return parseInt(el, 10); });
        const end = range[1].split(':').map((el) => { return parseInt(el, 10); });
        // not in range.
        if (start[0] > hour || end[0] < hour) {
            continue;
        }
        // within range completely
        if (start[0] < hour && end[0] > hour) {
            return true;
        }
        // check minutes...
        if (start[0] === hour) {
            if (start[1] < minute) {
                return true;
            }
            continue;
        }
        if (end[0] === hour) {
            if (end[1] > minute) {
                return true;
            }
            continue;
        }
    }
    return false;
};

export {
    isCoverageInRange
};
